import {SearchApiRequestConfig, SearchBuilder, ApiEnvironment, SearchQueryParams} from './search_constants';
import {ApiRequests} from '../api_requests/api_requests';
import {QueryItemBuilder} from '../api_requests/builders/query_item_builder';
import {ApplicationRequestConfigQueryBuilder} from '../api_requests/application_constants';
import {AxiosRequestConfig} from 'axios';
import {SearchResponse} from '../../model/record';
import {CustomDslBuilder} from "../api_requests/builders/custom_dsl_builder";

export class SearchApi {
  static getApiURL(apiEnv: string) {
    let apiURL = '';
    switch (apiEnv) {
      case ApiEnvironment.LOCAL:
        apiURL = 'http://localhost:3000';
        break;
      case ApiEnvironment.DEV:
        apiURL = 'https://resources.dev.education.nsw.gov.au/api/v2/search';
        break;
      case ApiEnvironment.TEST:
        apiURL = 'https://resources.test.education.nsw.gov.au/api/v2/search';
        break;
      case ApiEnvironment.PRE:
        apiURL = 'https://resources.pre.education.nsw.gov.au/api/v2/search';
        break;
      case ApiEnvironment.PROD:
        apiURL = 'https://resources.education.nsw.gov.au/api/v2/search';
        break;
    }
    return apiURL + '?';
  }

  static async search(options: SearchApiRequestConfig): Promise<SearchResponse> {
    let url = '';
    if (options.apiEnv) {
      const apiEnv = options.apiEnv ? options.apiEnv : ApiEnvironment.DEV;
      url = SearchApi.getApiURL(apiEnv);
    } else {
      url = process.env.RESOURCE_STORE_SEARCH_URL + '?';
    }

    if (options.options) {
      url += SearchBuilder.optionsBuilder(options.options);
    }

    if (options.standardFieldFilters) {
      url += SearchBuilder.standardFieldBuilder(options.standardFieldFilters);
    }

    if (options.sort) {
      url += SearchBuilder.sortBuilder(options.sort);
    }

    if (options.itemId) {
      url += SearchBuilder.itemIdBuilder(options.itemId);
    }

    if (options.keyword) {
      url += QueryItemBuilder.valueProp(options.keyword, SearchQueryParams.KEYWORD);
    }

    if (options.isHomePage) {
      url += QueryItemBuilder.valueProp(options.isHomePage, SearchQueryParams.IS_HOMEPAGE);
    }

    if (options.filters) {
      for (const filter of options.filters) {
        url += QueryItemBuilder.valueProp(filter.values, filter.field);
      }
    }

    if (options.includeApplicationRequestConfig) {
      url += ApplicationRequestConfigQueryBuilder.buildQueryString(options.application);
    }

    // remove the trailing & before calling the search Api
    url = url.replace(/&+$/, '');

    const axiosMethod = options.axiosMethod ? options.axiosMethod : 'POST';
    const axiosRequestObject: AxiosRequestConfig = {
      url,
      method: axiosMethod,
      headers: {...options.application}
    };

    if (options.options?.onlyMine || options.options?.onlySharedWithMe || options.options?.hasAccess || options.options?.onlySharedByMe) {
      options.customQuery = CustomDslBuilder.buildUserAccessDSL(options.options, options.customQuery);
    }

    if (options.customQuery) {
      axiosRequestObject.data = {customQuery: options.customQuery};
    }

    return await ApiRequests.executeRequest(axiosRequestObject);
  }

}
